import React from 'react';
import { useParams, Link } from "react-router-dom";
import Articles from './articles';

export default function ArticlesByTagId() {

    const { tagId } = useParams();

    return (
        <>
            <Articles tagId={tagId} tableHeight={'828px'}></Articles>
            <div style={{ textAlign: "center" }}>
                <Link to={{ pathname: "/articles" }}>
                    Torna alla lista dei tags
                </Link>
            </div>
        </>
    );
}
